import aboutMeIntroTour from './about_me_intro_tour';
import dashboardIntroTour from './dashboard_intro_tour';
import effectivenessIntroTour from './effectiveness_intro_tour';
import sidebarIntroTour from './sidebar_intro_tour';
import suggestionsIntroTour from './suggestions_intro_tour';
import undistractorIntroTour from './undistractor_intro_tour';

// Registry of tour definitions, keyed by data-tour-name-value. lite-intro and tools-intro are the same
// walk through the same table, differing only in the page that carries it and the payload it is handed.
export default {
  'about-me-intro': aboutMeIntroTour,
  'dashboard-intro': dashboardIntroTour,
  'effectiveness-intro': effectivenessIntroTour,
  'lite-intro': undistractorIntroTour,
  'sidebar-intro': sidebarIntroTour,
  'suggestions-intro': suggestionsIntroTour,
  'tools-intro': undistractorIntroTour,
};
